export default __webpack_public_path__ + "static/media/Turtlr-gameplay-screenshot-350px-233px.jpg.5ff05b92.webp";